export default "__VITE_ASSET__ubUWwLxN__"